import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { LOGIN_GOOGLE_PRIVACY_POLICY, LOGIN_GOOGLE_TERMS_AND_CONDITIONS } from '../../../constants/auth';
import { IFooterProps } from '../../../interfaces/globals';
import { TRANSLATIONS_GLOBAL } from '../../../translations/commons';
import { redirectToPage } from '../../../utils/utils';
import './Footer.scss';
import TextButton from '../../Buttons/TextButton/TextButton';

const Footer = ({ isAuthenticated = false }: IFooterProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleRedirect = (url: string) => {
    redirectToPage(navigate, url);
  };

  return (
    <footer className={`footer ${isAuthenticated ? 'footer--authenticated' : 'footer--unauthenticated'} w-full h-full`}>
      <div className="footer__content text-center">
        {isAuthenticated && (
          <div className="footer__policies flex justify-center items-center">
            {t(TRANSLATIONS_GLOBAL.footer.copyright)}
            <TextButton variant="primary" size="xs" action={() => handleRedirect(LOGIN_GOOGLE_TERMS_AND_CONDITIONS)}>
              {t(TRANSLATIONS_GLOBAL.footer.termsAndConditions)}
            </TextButton>
            <TextButton variant="primary" size="xs" action={() => handleRedirect(LOGIN_GOOGLE_PRIVACY_POLICY)}>
              {t(TRANSLATIONS_GLOBAL.footer.privacyPolicy)}
            </TextButton>
          </div>
        )}
        {!isAuthenticated && (
          <div className="footer__policies flex justify-center items-center">
            <div>{t(TRANSLATIONS_GLOBAL.footer.recaptcha)}</div>
            <TextButton variant="primary" size="xs" action={() => handleRedirect(LOGIN_GOOGLE_PRIVACY_POLICY)}>
              {t(TRANSLATIONS_GLOBAL.footer.privacyPolicy)}
            </TextButton>
            <TextButton variant="primary" size="xs" action={() => handleRedirect(LOGIN_GOOGLE_TERMS_AND_CONDITIONS)}>
              {t(TRANSLATIONS_GLOBAL.footer.termsAndConditions)}
            </TextButton>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
